import { widgetRegistry } from "#app/widgets/registry";
import { issueAttachmentsDef } from "./definitions/issue-attachments";
import { issueCommentsDef } from "./definitions/issue-comments";
import { issueCustomFieldsDef } from "./definitions/issue-custom-fields";
import { issueDescriptionDef } from "./definitions/issue-description";
import { issuePropertiesDef } from "./definitions/issue-properties";
import { issueUpdatesDef } from "./definitions/issue-updates";

// Issue widgets register into the shared app registry but carry NO catalog
// entries (never offered by any gallery) and are never persisted — the summary
// tab mounts a hardcoded client-local stack, so the server widget-type
// allowlist doesn't list them.
widgetRegistry.register(issuePropertiesDef);
widgetRegistry.register(issueUpdatesDef);
widgetRegistry.register(issueCustomFieldsDef);
widgetRegistry.register(issueDescriptionDef);
widgetRegistry.register(issueCommentsDef);
widgetRegistry.register(issueAttachmentsDef);
